import { DateUtils } from './../../../base/utils/date-utils';
import { DataManager } from '@syncfusion/ej2-data';
import { ClientDTO, CreateExportJobDTO, ExportJobDTO, ExportJobStatus, ExportJobType, ReportFileType } from 'src/app/base/models/models.swagger.generated';
import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GridModule, RowSelectEventArgs } from '@syncfusion/ej2-angular-grids';
import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { ClientService } from 'src/app/base/services/client/client.service';
import { ClientAutocompleteComponent } from 'src/app/base/shared/client-autocomplete/client-autocomplete.component';
import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';
import { TitleBarComponent } from 'src/app/base/shared/title-bar/title-bar.component';
import { exportJobsCreateRoute } from 'src/app/core/routing/route-names';
import { AvpCustomAdaptor } from 'src/app/base/shared/syncfusion/avp-custom-adaptor';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { ExportJobService } from './export-job.service';
import { ExportJobEditFormComponent } from './export-job-edit-form/export-job-edit-form.component';
import { Router } from '@angular/router';
import { DateTime } from 'luxon';
import { downloadFile, getStatusClassName } from './export-job-common';
import { AuthService } from 'src/app/base/services/auth.service';

@Component({
  selector: 'app-export-jobs',
  templateUrl: './export-job.component.html',
  styleUrls: ['./export-job.component.scss'],
  imports: [TitleBarComponent, ClientAutocompleteComponent, GridModule, TranslateModule, ToolbarModule, ExportJobEditFormComponent]
})

export class ExportJobComponent extends GridBaseComponent implements OnInit {

  @ViewChild('exportJobFormComponent')
  public exportJobFormComponent: ExportJobEditFormComponent;

  public exportJob: ExportJobDTO = null;

  public JobTypes = ExportJobType;
  public FileTypes = ReportFileType;
  public ExportJobStatus = ExportJobStatus;

  public override get selectedClient(): ClientDTO {
    return this.clientService.selectedClient;
  }

  private lastAddedJobId: number = null;
  private useDetailedCompanyName = false;
  constructor(
    translateService: TranslateService,
    clientService: ClientService,
    private router: Router,
    private exportJobService: ExportJobService,
    private spinnerService: SpinnerService,
    private authService: AuthService
  ) {
    super(clientService, translateService, exportJobService);

  }

  ngOnInit() {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.exportJobService, this.spinnerService)
    });

    if (this.selectedClient) {
      this.exportJobService.selectedClientId = this.selectedClient.id
    }
    this.useDetailedCompanyName = this.authService.isUserAdmin();
  }

  public onRowSelected(args: RowSelectEventArgs): void {
    this.exportJob = args.data as ExportJobDTO;
    this.exportJobService.getById(this.exportJob.id).subscribe((dto: ExportJobDTO) => {
      this.exportJob = dto;
    });
  }

  public onRefresh() {
    this.exportJobFormComponent?.canCloseForm().subscribe((canClose: boolean) => {
      if (!canClose) {
        return;
      }

      this.onCancel();
      this.grid.refresh();
    });
  }

  public override onClientSelected(client: ClientDTO) {
    this.exportJobFormComponent?.canCloseForm().subscribe((canClose: boolean) => {
      if (!canClose) {
        return;
      }

      this.onCancel();
      this.exportJobService.selectedClientId = client?.id
      this.clientService.selectedClient = client;
      super.onClientSelected(client);
    });
  }

  public onCancel() {
    this.exportJob = null;
    this.grid.selectRows([]);
  }

  public addJob() {
    if (!this.selectedClient) {
      return;
    }
    this.exportJobFormComponent.canCloseForm().subscribe((canClose: boolean) => {
      if (!canClose) {
        return;
      }
      this.exportJob = new ExportJobDTO();
      this.router.navigate([exportJobsCreateRoute]);
    });
  }

  public onDelete() {
    this.exportJobService.deleteRecord(this.exportJob.id).subscribe(() => {
      this.exportJob = null;
      this.grid.refresh();
    });
  }

  public create(dto: CreateExportJobDTO) {
    dto.clientId = this.selectedClient.id;
    this.exportJobService.addRecord(dto).subscribe((dto: ExportJobDTO) => {
      this.lastAddedJobId = dto.id;
      this.grid.refresh();
      this.exportJob = dto;
    });
  }

  public getDisplayDateTime(date: DateTime): string {
    if (date) {
      return DateUtils.formatMonthYear(date.toJSDate());
    }
    return null;
  }

  public onDataBound() {
    if (this.lastAddedJobId && this.grid && this.grid.dataSource) {
      this.grid.selectRow(this.grid.getRowIndexByPrimaryKey(this.lastAddedJobId));
      this.lastAddedJobId = null;
    }
  }

  public getStatusClassName(args: any): string {
    return getStatusClassName(args as ExportJobStatus)
  }

  public downloadFile(exportJob: ExportJobDTO): void {
    downloadFile(exportJob, this.exportJobService);
  }

  public getCompanyName(data: ExportJobDTO) {
    if (this.useDetailedCompanyName) {
      let name = data.clientName;
      if (data.companyName) {
        name += ' / ' + data.companyName;
      }
      return name;
    }
    return data.companyName;
  }

  protected override initializeEditForm(data: any): void {
    throw new Error('Method not implemented.');
  }
  protected override getEditDialogTitleParams(rowData: any) {
    throw new Error('Method not implemented.');
  }
}
